module.exports = __webpack_public_path__ + "static/media/building.63d37a99.svg";